import React from "react";

//component ================  
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import Card from "components/Card/Card.jsx"; 
import CardContent from '@material-ui/core/CardContent'; 

import Radio from '@material-ui/core/Radio'; 
import FormControlLabel from '@material-ui/core/FormControlLabel'; 
import TextField from '@material-ui/core/TextField';
import CardIcon from "components/Card/CardIcon" 
import CardHeader from "components/Card/CardHeader"

import Slider from '@material-ui/core/Slider';

import { compose } from "recompose"
import { connect } from "react-redux"
import { updateAnswers } from "store/actions"
import { replaceNumberQuestion } from "helpers/ConvertString"

//icon ============ 
import FiberManualRecord from "@material-ui/icons/FiberManualRecord";

import withStyles from "@material-ui/core/styles/withStyles";

// import loginPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle.jsx";
function valuetext(value) {
  var val = value/10 
  return `${val} คะแนน`;
}
function valueLabelFormat(value,answer) { 
  if(answer[0].label != "1"){
    return answer.findIndex((mark) => mark.value === value) + " P";
  }else{
    return (answer.findIndex((mark) => mark.value === value)+1) + " P";
  }
}
const PrettoSlider = withStyles({
  root: {
    color: '#9fdff3',
    height: 8,
  },
  thumb: {
    height: 24,
    width: 24,
    color:"#00a1ff",
    backgroundColor: '#fff',
    border: '2px solid currentColor',
    marginTop: -8,
    marginLeft: -12,
    '&:focus, &:hover, &$active': {
      boxShadow: 'inherit',
    },
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 4px)',
  },
  track: {
    height: 8,
    borderRadius: 4,
  },
  rail: {
    height: 8,
    borderRadius: 4,
  },
})(Slider);
class QSliderComponent extends React.Component { 
    constructor(props) {
      super(props)
      this.state = {  
        countUpdate:0,
        headerLabel:this.props.headerLabel, 
        language:this.props.language, 
        dataQuestion:this.props.dataQuestion, 
        sectionName:this.props.sectionName, 
        questionName:this.props.questionName,
        value:this.props.value,
        answer_gen:[],
        one_per_point:0,
        default_per_point:null,
        current_choosed:null
      }
    }  
    componentDidMount(){  
      var per = 0;
      var answer = this.state.dataQuestion[this.state.language].answer
      per = 100/(answer.length-1)
      var last_val = (
                      this.state.value[this.state.sectionName] && 
                      this.state.value[this.state.sectionName][this.state.questionName] &&
                      this.state.value[this.state.sectionName][this.state.questionName].value
                    )?this.state.value[this.state.sectionName][this.state.questionName].value:null
      // var default_per_point = Math.floor(answer.length/2)*per 
      var default_per_point = 4*per
      if(answer.length == 11){
        default_per_point = Math.floor(answer.length/2)*per 
      }
      if(last_val){ 
        if(answer.length == 11){
          default_per_point = (last_val)*per
        }else{
          default_per_point = (last_val-1)*per
        }
      }
      var new_answer = [] 
      answer.map((data,index)=>{
        var a = {
          value: per*(index),
          label: data
        } 
        new_answer.push(a);
      })
     
      this.setState({
        one_per_point:per,
        answer_gen : new_answer,
        default_per_point:default_per_point
      },()=>{
        if(!last_val) this.handleChangeRadioEnabled(default_per_point)
      })
    }
    
    handleChangeRadioEnabled(choosed) {  
      if(choosed == this.state.current_choosed)return
      var answers = {};  
      answers.type = this.state.dataQuestion.type 
      answers.value = Math.round(choosed/this.state.one_per_point) 
      var answer = this.state.dataQuestion[this.state.language].answer
      if(answer[0] == 1){
        answers.value ++
      }
      this.setState({
        current_choosed:choosed,
        answers:answers
      },()=>{
        this.props.updateAnswersCallback(this.state.sectionName,this.state.questionName,answers,()=>{ 
          this.setState({countUpdate:++this.state.countUpdate})
        }) 
      })
    }; 
    renderQuestion(){
      const date = this.state.dataQuestion 
      return (
        <div> 
          <div className="redio-question m-b-2">
            {
              !this.props.hideNumberQuestion?
                <span className="m-r-2 W100">
                  {replaceNumberQuestion(this.state.questionName) +") "}
                </span> 
              :"" 
            }
           
            {date[this.state.language].question}
          </div> 
          <GridContainer className="slider-p">
            <GridItem xs={12}>
              {
                (this.state.default_per_point)?
                  <PrettoSlider
                    defaultValue={this.state.default_per_point}
                    valueLabelFormat={(val)=>valueLabelFormat(val,this.state.answer_gen)}
                    getAriaValueText={valuetext}
                    aria-labelledby="discrete-slider-custom"
                    step={this.state.one_per_point}
                    valueLabelDisplay="auto"
                    marks={this.state.answer_gen}
                    onChange={(e, val) => this.handleChangeRadioEnabled(val)}
                  />
                  :""
              }
            </GridItem> 
          </GridContainer>
        </div>
      )  
    }
     
    render() { 
      return (     
        <Card className="card-bg-90">
          {
            (this.state.headerLabel)?
            <CardHeader color="info" icon>
              <CardIcon color="danger" className="icon-question">
                <span className="title-question">{this.state.headerLabel}</span>
              </CardIcon> 
            </CardHeader>
            :""
          } 
          <CardContent> 
          {
            this.renderQuestion()
          } 
          </CardContent>  
        </Card> 
      );
    }
}
 
function mapStateToProps({ answers }) { 
  return {
    answers: answers
  }
}

export default compose(
  withStyles(regularFormsStyle),
  connect(
    mapStateToProps,
    { updateAnswers }
  )
)(QSliderComponent)